import React from "react";
import styled from "styled-components/macro";
import { DefaultFont } from "../../styles/fonts";

interface IButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
}

export const ButtonsGroupContainer = styled.div`
  border: 1px solid ${(props) => props.theme.colors.softGray};
  border-radius: 8px;
  background: ${(props) => props.theme.colors.bgSecondary};
  padding: 4px;
  display: flex;
  gap: 2px;
`;

export const Button = styled.button<IButton>`
  border: 1px solid
    ${(props) =>
      props.selected
        ? props.theme.colors.textDimmed
        : props.theme.colors.bgSecondary};
  outline: none;
  padding: 5px 32px;
  border-radius: 6px;
  transition: 0.3s;
  background: ${(props) => props.theme.colors.bgSecondary};
  display: flex;
  align-items: center;

  & > span {
    position: relative;
  }

  &:hover {
    cursor: pointer;
  }

  ${DefaultFont};
  font-size: 14px;
  font-weight: ${(p) => p.theme.font.weightMedium};

  color: ${(props) =>
    props.selected ? props.theme.colors.text : props.theme.colors.textDimmed};

  @media ${(props) => props.theme.media.phone} {
    font-weight: ${(props) => props.theme.text.default.mobileWeight};
  }

  svg {
    width: 20px;
    height: auto;
    margin-right: 10px;
  }
`;
